<template>
  <HomeCardTemporary v-if="userStore.userInfo?.userType === 'HOST'" />
  <HomeRecentlyUsed v-if="subscriptionStore.currentPlan !== 'FREE'" />
  <BannerEvent />
  <div class="itp-card-area">
    <h1>{{ t('label_start_interpretation') }}</h1>
    <div class="inr">
      <CardChatType v-for="chatType in chatTypeList" :key="chatType" :chat-type="chatType" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BannerEvent from '@/components/domains/mobile/home/BannerEvent.vue';
import CardChatType from '@/components/domains/mobile/home/CardChatType.vue';
import HomeCardTemporary from '@/components/domains/mobile/home/HomeCardTemporary.vue';
import HomeRecentlyUsed from '@/components/domains/mobile/home/HomeRecentlyUsed.vue';
import { useMobileInit } from '@/composables/domains/mobile/useMobileInit';
import { useSubscriptionStore } from '@/stores/subscription';
import { useUserStore } from '@/stores/user';

const { t } = useI18n();

const userStore = useUserStore();
const subscriptionStore = useSubscriptionStore();

const chatTypeList: string[] = ['conference', 'meeting', 'audience', 'general', 'single'];

const { initializeNativeInfo } = useMobileInit();
initializeNativeInfo();

onMounted(async () => {
  if (!userStore.userInfo) {
    await userStore.fetchUserInfo();
  }
});
</script>

<style scoped lang="scss">
.itp-card-area {
  padding-bottom: 2rem;
  h1 {
    font-size: $size-xl;
    padding: 2.5rem 0 0.75rem 0;
  }
}
</style>
